import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '@/shared/context/context';
import signalRMessages from '@/redux/actions/signalRMessages';
import useNotification from '@/shared/hooks/UseNotification';
import useSocketEvent from '@/shared/hooks/useSocketEvent';

const getMessageKey = (messageKey: string, homeownerAssociationName: string | null) =>
  homeownerAssociationName ? messageKey : `${messageKey}WithoutName`;

const useGlobalManualOctopusSyncMessages = () => {
  const { currentTeamUser } = useContext(AppContext);
  const { sendNotification } = useNotification();
  const { t } = useTranslation();

  useSocketEvent(
    signalRMessages.ManualHoaOctopusSyncCompleted,
    (userId: string, _homeownerAssociationId: string, homeownerAssociationName: string | null) => {
      if (userId !== currentTeamUser?.userId) return;

      sendNotification({
        message: t(
          getMessageKey('_globalMessages.manualOctopusSyncCompleted', homeownerAssociationName),
          {
            homeownerAssociationName,
          },
        ),
        options: {
          autoHideDuration: 10000,
        },
        variant: 'success',
      });
    },
  );

  useSocketEvent(
    signalRMessages.ManualHoaOctopusSyncFailed,
    (
      failureReason: string,
      userId: string,
      _homeownerAssociationId: string,
      homeownerAssociationName: string | null,
    ) => {
      if (userId !== currentTeamUser?.userId) return;

      sendNotification({
        message: t(
          getMessageKey('_globalMessages.manualOctopusSyncFailed', homeownerAssociationName),
          {
            homeownerAssociationName,
            reason: t(`_globalMessages.manualOctopusSyncFailureReasons.${failureReason}`, {
              defaultValue: t('_globalMessages.manualOctopusSyncFailureReasons.unknownReason'),
            }),
          },
        ),
        options: {
          autoHideDuration: 10000,
        },
        variant: 'error',
      });
    },
  );
};

export default useGlobalManualOctopusSyncMessages;
